import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      numid: 0,
      id: 'jan', 
      name: i18n.t('tipos.meses.jan'),
      shortname: i18n.t('tipos.meses.short.jan')
    },
    {
      numid: 1,
      id: 'feb',
      name: i18n.t('tipos.meses.feb'),
      shortname: i18n.t('tipos.meses.short.feb')
    },
    {
      numid: 2,
      id: 'mar',
      name: i18n.t('tipos.meses.mar'),
      shortname: i18n.t('tipos.meses.short.mar')
    },
    {
      numid: 3,
      id: 'apr',
      name: i18n.t('tipos.meses.apr'),
      shortname: i18n.t('tipos.meses.short.apr')
    },
    {
      numid: 4,
      id: 'may',
      name: i18n.t('tipos.meses.may'),
      shortname: i18n.t('tipos.meses.short.may')
    },
    {
      numid: 5,
      id: 'jun',
      name: i18n.t('tipos.meses.jun'),
      shortname: i18n.t('tipos.meses.short.jun')
    },
    {
      numid: 6,
      id: 'jul',
      name: i18n.t('tipos.meses.jul'),
      shortname: i18n.t('tipos.meses.short.jul')
    },
    {
      numid: 7,
      id: 'aug',
      name: i18n.t('tipos.meses.aug'),
      shortname: i18n.t('tipos.meses.short.aug')
    },
    {
      numid: 8,
      id: 'sep',
      name: i18n.t('tipos.meses.sep'),
      shortname: i18n.t('tipos.meses.short.sep')
    },
    {
      numid: 9,
      id: 'oct',
      name: i18n.t('tipos.meses.oct'),
      shortname: i18n.t('tipos.meses.short.oct')
    },
    {
      numid: 10,
      id: 'nov',
      name: i18n.t('tipos.meses.nov'),
      shortname: i18n.t('tipos.meses.short.nov')
    },
    {
      numid: 11,
      id: 'dec',
      name: i18n.t('tipos.meses.dec'),
      shortname: i18n.t('tipos.meses.short.dec')
    }
  ]
}

export function MONTHS (state) {
  return configHelper.getConfig(state, 'MONTHS', GenerateConfig)
}
